import { render, staticRenderFns } from "./ClientChatHandler.vue?vue&type=template&id=4b1071a2&scoped=true&"
import script from "./ClientChatHandler.vue?vue&type=script&lang=js&"
export * from "./ClientChatHandler.vue?vue&type=script&lang=js&"
import style0 from "./ClientChatHandler.vue?vue&type=style&index=0&id=4b1071a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1071a2",
  null
  
)

export default component.exports